import { render, staticRenderFns } from "./PageManagement.vue?vue&type=template&id=5bef870d&scoped=true"
import script from "./PageManagement.vue?vue&type=script&lang=js"
export * from "./PageManagement.vue?vue&type=script&lang=js"
import style0 from "./PageManagement.vue?vue&type=style&index=0&id=5bef870d&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef870d",
  null
  
)

export default component.exports